import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_OrganizationUserProfile.scss';
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { Component_AccountThumbnail } from '@nu-art/user-account-frontend/index';
import { DataGrid } from '@app/styles';
import { ModuleFE_User } from '../../../../../_entity/user/index.js';
export class Component_OrganizationUserProfile extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.user = nextProps.user;
        state.account = nextProps.account;
        return state;
    }
    userAcronymComposer = (accountId) => {
        const user = ModuleFE_User.cache.unique(accountId);
        if (!user || (!user.firstName || !user.surname))
            return;
        return user.firstName.charAt(0) + user.surname.charAt(0);
    };
    renderDetails = () => {
        return _jsxs(DataGrid.Grid, { className: 'details', children: [_jsx(DataGrid.Label, { children: "Title" }), _jsx(DataGrid.Data, { children: this.state.user.title?.length ? this.state.user.title : '-' }), _jsx(DataGrid.Label, { children: "First Name" }), _jsx(DataGrid.Data, { children: this.state.user.firstName?.length ? this.state.user.firstName : '-' }), _jsx(DataGrid.Label, { children: "Surname" }), _jsx(DataGrid.Data, { children: this.state.user.surname?.length ? this.state.user.surname : '-' }), _jsx(DataGrid.Label, { children: "Email" }), _jsx(DataGrid.Data, { children: this.state.account.email.length ? this.state.account.email : '-' })] });
    };
    renderUserThumbnail = () => {
        return _jsxs(LL_V_L, { className: 'org-user-profile-column', children: [_jsx(Component_AccountThumbnail, { accountId: this.state.account._id, acronymComposer: this.userAcronymComposer }), this.renderDetails()] });
    };
    render() {
        return _jsx(LL_V_L, { className: 'org-user-profile', children: this.renderUserThumbnail() });
    }
}
//# sourceMappingURL=Component_OrganizationUserProfile.js.map